import { cva, type VariantProps } from "class-variance-authority"

/**
 * Shared field styles: default vs floating (CRM / Eataly).
 * Floating pairs with rules in `app.css` (`.floating-input`, sibling `.floating-label`).
 */
export const inputFieldVariants = cva(
  "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        /** Stacked label (Eataly Library / iscrizione): min 44px, radius token */
        default:
          "min-h-[var(--field-floating-min-height,2.75rem)] rounded-[var(--radius-sm)] py-2.5 text-base md:text-sm",
        search:
          "min-h-[var(--field-search-height,2.5rem)] rounded-[var(--radius-sm)] py-2 text-base md:text-sm",
        floating:
          "floating-input h-auto min-h-[var(--field-floating-min-height,3.5rem)] rounded-[var(--radius-sm)] border-input py-3 md:py-3 text-base md:text-base text-[var(--field-text-color)] tracking-[0.16px]",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

/** Tailwind classes for floating labels (sibling after `.floating-input` in markup). */
const floatingFormLabelClassName =
  "floating-label pointer-events-none absolute top-1/2 left-3 z-10 inline-flex max-w-[calc(100%-1.5rem)] -translate-y-1/2 items-center gap-0.5 rounded-sm px-1 text-base leading-6 font-normal transition-[top,font-size,line-height] duration-200 ease-out select-none"

export const labelFieldVariants = cva(
  "flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50",
  {
    variants: {
      variant: {
        default: "text-foreground",
        search: "text-foreground",
        floating: floatingFormLabelClassName,
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export type InputFieldVariantProps = VariantProps<typeof inputFieldVariants>
export type LabelFieldVariantProps = VariantProps<typeof labelFieldVariants>
